import React, { Component } from "react";
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import Steps, { Step } from 'rc-steps';


export default class Stepper extends Component {
	render() {
		return (
			<Steps direction="vertical">
                {this.props.steps.map(x => 
                    <Step title={x.title} description={x.description} status="process" />
                )}
            </Steps>
		);
	}
}
